import type { Components } from '@mui/material'

export const OmuiSegmentedControl: NonNullable<Components['OmuiSegmentedControl']> = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.bg.surface.inset,
      borderRadius: theme.shape['radius-lg'],
      padding: theme.spacing(0.5),
      gap: theme.spacing(0.5),
      '& .MuiToggleButton-root': {
        borderRadius: theme.shape['radius-md'],
        backgroundColor: theme.palette.bg.invisible,
        color: theme.palette.text.muted,
        ...theme.typography['body-medium'],
        gap: theme.spacing(1),
        border: 'none',
        '& > svg:not(.MuiSvgIcon-root)': {
          width: '18px',
          height: '18px',
        },
        // Nested one level deeper than the shared 20px icon rule, so this wins
        '& .MuiSvgIcon-root': {
          fontSize: '1.125rem',
        },
        '&:hover': {
          color: theme.palette.text.default,
          backgroundColor: theme.palette.bg.invisible,
        },
        '&.Mui-disabled': {
          border: 'none',
          color: theme.palette.text.subtle,
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.bg.surface.elevated,
          color: theme.palette.text.default,
          boxShadow: theme.customShadows.xs,
          '&:hover': {
            backgroundColor: theme.palette.bg.surface.elevated,
          },
        },
      },
      // Outranks MuiToggleButton's icon-button padding for Nucleo icons (`:has(> svg)`), which pads every side
      '&& .MuiToggleButton-root': {
        padding: theme.spacing(1, 2.5),
        // An icon-only tab has no text line, so hold it to a labelled tab's height
        minHeight: '32px',
      },
      // MUI's default grouped spacing would otherwise fight the gap
      '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': { marginLeft: 0 },
      // Compound selector so this outranks the grouped-border restore in MuiToggleButton
      '&& .MuiToggleButtonGroup-grouped': { border: 'none' },
    }),
  },
}
